module.exports = __webpack_public_path__ + "static/media/bg03.5a14773f.jpg";